import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { IEnumerable } from "../../core/models/ModelHelpers";
import { TextField } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { EventActionStepTypes } from "../../core/models/Enum/EventActionStep";
import { LocalCache } from "../../helpers/cache";

type ChargeModalComponentProps = {
  //header: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isOpen: boolean;
  setOpen: (value: boolean) => void;
  businessEvent_id: IEnumerable;
  currentChargeValidationLevel: number;
  choiceHandlerFunction: (comment: string) => void;
  confirmationSelected: boolean;
};

const ModalStyle = {
  headerStyle: {
    backgroundColor: "#6B717F",
    color: "#ffffff",
    fontSize: "1rem",
    fontFamily: "Linde,Arial,Roboto,-apple-system,sans-serif",
    fontWeight: 400,
    lineHeight: 1.5,
    paddingLeft: "8px",
  },
};

const confirmationMessages = [
  "O fluxo será encerrado e a cobrança será enviada para o CSC.",
  "Seu pedido seguirá para confirmação de 2º nível.",
  "Encerra o fluxo e não envia para o CSC.",
];

const ChargeApprovalModal = ({
  isOpen,
  setOpen,
  businessEvent_id,
  currentChargeValidationLevel,
  confirmationSelected,
  choiceHandlerFunction,
}: ChargeModalComponentProps) => {
  const toastr = useSnackbar();
  const [comment, setComment] = React.useState<string>("");

  const userInfo: any = new LocalCache().get("user");

  const handleClickConfirmAction = () => {
    if (!comment) {
      toastr.enqueueSnackbar("Comentário deve ser preenchido", {
        variant: "error",
      });
      return;
    }
    choiceHandlerFunction(comment);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title" style={ModalStyle.headerStyle} disableTypography>
          {confirmationSelected ? "Aprovar Cobrança" : "Rejeitar Cobrança"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <b>{`Evento #${businessEvent_id}`}</b>
          </DialogContentText>
          <DialogContentText>
            <b>
              {confirmationSelected
                ? confirmationMessages[0]
                : currentChargeValidationLevel === 1
                ? userInfo && userInfo.grupo && userInfo.grupo.nome !== "Diretor"
                  ? confirmationMessages[1]
                  : confirmationMessages[2]
                : confirmationMessages[2]}
            </b>
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="comment"
            label="Inserir comentário (obrigatório)"
            type="text"
            fullWidth
            required
            onChange={(evt) => setComment(evt.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleClickConfirmAction} variant="outlined" color="primary" autoFocus>
            {confirmationSelected ? "Aprovar" : "Rejeitar"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ChargeApprovalModal;
